import React, {Component}  from 'react';
import Loading             from './common/loading';
import { Globals }         from '../constants';
import { Link }            from 'react-router-dom';
import axios               from 'axios';
import { space2hyphen, space2hyphenForSlug } from '../HelperFunctions';

import BackgroundImage from "react-background-image-loader";

import Axios from "axios";

class LeftUpdatesList extends Component {
  constructor(props) {
    super(props);
    this.state = {
    //   seriesApiPath: Globals.ApiUrl + 'api/v2/series/featured',
    //   seriesApiResp: [],
       updateApiPath: Globals.ApiUrl + 'api/news?page=1&per_page=6',
       updateApiResp: [],
       videosPath:
        Globals.ApiUrl +
        "api/v1/user_api/home_videos?telco=ufone&app_name=" +
        Globals.appName,
        videosApiResp: [],

      error: null, //by Tariq
      isLoading: true, //by Tariq
      isLoaded: false, //by Tariq
      counter: 0, //by Tariq

    //   phone: '',
    //   pin: '',
    //   inputName: 'phone',
    //   inputValue: '',
    //   phonePlaceholder: Globals.login.phonePlaceholder,
    //   pinSent: false,
    //   pinPlaceholder: Globals.login.pinPlaceholder,
    //   task: 'phone',
    //   user: [],
    //   redirect: false,
    //   btnTxt: 'Continue',
    //   btnDisbaled: false,
      // apiPath: 'https://mobisub.cricwick.mobi/main/',
    //   message: '',
    //   heading: Globals.login.enterNumber,
    //   enterPin: Globals.login.enterPin,
      // heading: 'Please Enter Your Jazz Number. Prepaid users will be charged 2.38 per day.',
    //   strings: {
    //     somethingWentWrong: 'Something went wrong. Please try again later!',
    //     invalidPin: 'Invalid Pincode!',
    //     invalidPhone: Globals.login.invalidPhone,
    //   },
    };

    this.getVideos = this.getVideos.bind(this);

  }

  async componentDidMount() {
     await this.getSeriesRecords();
     let url = this.state.videosPath,
      resp;

    try {
      resp = await Axios.get(url);
      if (resp.status == 200) {
        this.setState({ videosApiResp: resp.data.timeline_videos });
      }
    } catch (error) {
      console.log("error fetching latest videos");
    }
     if(this.state.error){
        await this.knockingNetWorking();
     }
  }

  //========================New Method By Tariq =================================
  getSeriesRecords = async () => {
    let updatesUrl = this.state.updateApiPath,
            updatesResp;
    try {
                  updatesResp = await axios.get(updatesUrl);
                  const {data} = await updatesResp.data;
                  this.setState(() => {
                  return {
                           updateApiResp: data,         //updatesResp.data.data,
                                   error: null,
                               isLoading: false,
                                isLoaded: true,
                                error   : null
                          };
                  });

    }catch (error) {
                console.log('error fetching series');
                this.setState(() => {
                return {error: error, isLoaded:false};
                });
    }

}

getVideos() {
  if (this.state.videosApiResp) {
    return this.state.videosApiResp.map((video, i) => {
      return (
        <VideoCardSm
          key={"vcs-" + i}
          image={this.state.videosImage}
          data={video}
        />
      );
    });
  }
  return "";
}

//========================================================================


knockingNetWorking=async()=>{
  for(let i=0; i < 3; i++ ){
      setTimeout(()=>{
        this.getSeriesRecords();
      }, 15000 );
      if(this.state.isLoaded)
             return;
   }
}


//==================================End========================================
    render() {
        const {updateApiResp, isLoading, error} =  this.state;
            if(isLoading){
                return(<div className="latest-updates card px-3 py-3">
                         <h2 className="pb-3">Latest Updates</h2>
                           <Loading />
                        </div>);
            }else if(error){
                return(<div className="latest-updates card px-3 py-3">
                            <h2 className="pb-3">Latest Updates</h2>
                             <Loading />
                        </div>);
            }else{
                return(
                  <>
                  <div className="card mt-2 p-3">
        <div className="d-flex overflow-x-auto justify-content-between border-bottom align-items-center mb-2">
              <div>
                <p className="font-weight-semi-bold text-uppercase" style={{fontSize: "1.5rem", fontWeight: "600",}}>
                  VIDEO HIGHLIGHTS
                </p>
              </div>
              <div>
                <Link to="/videos">
                  <h2 className="text-uppercase">
                    View All
                  </h2>
                </Link>
              </div>
            </div>
          {this.getVideos()}
        </div>
                  <div className="latest-updates mt-2 card px-3 py-3">
                        <p className="pb-3 mb-0" style={{fontSize: "1.5rem", fontWeight: "600",}}>LATEST UPDATES</p>
                        <ul style={{paddingLeft:0+'px'}}>
                              {updateApiResp.map((update, i) => (
                                  <div key={'lu-'+i} className="card-body p-0 pb-4 mb-4 font-weight-semi-bold">
                                      {/*<a href={"/stories/news/"+update.id}>{update.title}</a>*/}
                                      <Link to={"/news/" + update.id + "/" + space2hyphenForSlug(update.title)}> {update.title} </Link>
                                </div>
                              ))
                              }
                        </ul>
                  </div>
                  </>
                )
            }
    }

    

}

const VideoCardDescription = (props) => (
  <div className="custom-clamp-text">
    <p className="text-secondary mb-0 font-weight-normal text-nowrap mb-1">
      {props.data.match_obj.title}
    </p>
    <p className="text-black anchor mb-0 m-f-13 font-weight-semi-bold flex-fill">
      {props.data.title}
    </p>
  </div>
);

const VideoCardSm = (props) => (
  <div className="mb-2">
    <Link
      to={
        "/video/highlights/" +
        props.data.id +
        "/" +
        space2hyphenForSlug(props.data.title)
      }
      className="d-flex "
    >
      <div className="w-40 position-relative">
        {/* <div className="sixteen-by-nine bg-center-cover" style={{backgroundImage: 'url('+props.data.thumb+')'}}></div> */}
        <BackgroundImage
          className="sixteen-by-nine bg-center-cover"
          src={props.data.thumb}
          placeholder={Globals.placeholderPlain4x3}
        >
          <div className="fa fa-play-circle play-btn-lg play-btn-xs" />
        </BackgroundImage>
      </div>
      <div className="pl-2 video-card-right-section">
        <VideoCardDescription data={props.data} />
      </div>
    </Link>
  </div>
);

export default LeftUpdatesList;
